export function isWithValue<Item, Key extends keyof Item>(key: Key) {
    return function (item: Item): item is Item & Record<Key, NonNullable<Item[Key]>> {
        return item[key] !== null && item[key] !== undefined;
    };
}
